<template>
  <span class="ts-link" :class="{ primary: type === 'primary' }">
    <span v-if="disabled" class="disabled"><slot></slot></span>
    <a v-else v-bind="$attrs" v-on="$listeners">
      <slot></slot>
    </a>
  </span>
</template>

<style lang="scss">
.ts-link {
  text-decoration: none;
  font-family: Roboto;
  font-size: 12px;
  color: #6d7587;
  cursor: pointer;

  &.primary {
    color: #39c88c;
  }
}

.disabled {
  color: #acbacc;
}
</style>

<script>
export default {
  name: 'TsLink',
  props: {
    type: {
      type: String,
      default: 'default'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
};
</script>
